module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kfftu"))).then(() => parcelRequire('1iHdE'));